export const notificationPreferencesTranslationConfig: {
  common: string[];
  feature: string;
} = {
  common: ['CommonUI.Messages', 'CommonUI.Controls'],
  feature: 'Notifications.NotificationStream'
};

export default notificationPreferencesTranslationConfig;
